import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import { BLOCK_DEFAULTS, BUTTON_TYPES } from '../../apps/homepage/constants';
import ButtonLink from '../ButtonLink';
import camelCase from '../../utils/strings/camelCase';
import css from './Heading.module.scss';
import newLineToBreakTag from '../../utils/strings/newLineToBreakTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ctaPadding = 48;
var ctaFontSize = 16;
var ctaLetterSpacing = -0.25;

var calcMinWidth = function calcMinWidth(_ref) {
  var cta = _ref.cta,
      ctaExtra = _ref.ctaExtra;
  var textLength = cta.length > ctaExtra.length ? cta.length : ctaExtra.length;
  var width = ctaFontSize * textLength;
  var spacingOffset = Math.abs(width * ctaLetterSpacing);
  return width - spacingOffset + ctaPadding;
};

var Wrap = function Wrap(_ref2) {
  var children = _ref2.children,
      layout = _ref2.layout,
      linkHero = _ref2.linkHero,
      sticky = _ref2.sticky,
      url = _ref2.url;
  var layoutClass = css[camelCase(layout)];

  if (linkHero) {
    return /*#__PURE__*/_jsx("a", {
      className: cc([layoutClass, css.linkHero]),
      href: url,
      children: children
    });
  }

  if (sticky) {
    return /*#__PURE__*/_jsx("div", {
      className: cc([layoutClass, css.sticky]),
      children: children
    });
  }

  return children;
};

Wrap.propTypes = {
  children: false
};
Wrap.propTypes = {
  children: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  layout: PropTypes.string.isRequired,
  linkHero: PropTypes.bool.isRequired,
  sticky: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired
};

var Heading = function Heading(_ref3) {
  var buttonType = _ref3.buttonType,
      buttonTypeExtra = _ref3.buttonTypeExtra,
      className = _ref3.className,
      cta = _ref3.cta,
      ctaExtra = _ref3.ctaExtra,
      layout = _ref3.layout,
      overlayLeft = _ref3.overlayLeft,
      subtitle = _ref3.subtitle,
      subtitleColor = _ref3.subtitleColor,
      title = _ref3.title,
      titleColor = _ref3.titleColor,
      url = _ref3.url,
      urlExtra = _ref3.urlExtra;
  var bottom = layout.indexOf('BOTTOM') > -1;
  var center = layout.indexOf('CENTER') > -1;

  var ctaButtonType = _defineProperty({}, BUTTON_TYPES[buttonType], true);

  var ctaExtraButtonType = _defineProperty({}, BUTTON_TYPES[buttonTypeExtra], true);

  var hasCta = !!cta && !!url;
  var hasCtaExtra = !!ctaExtra && !!urlExtra;

  if (!title && !subtitle && !hasCta && !hasCtaExtra) {
    return false;
  }

  var rootClass = cc([css.root, _defineProperty({}, css.center, center), _defineProperty({}, css.overlayLeft, overlayLeft), css[camelCase(layout)], className]);
  var style = hasCtaExtra ? {
    minWidth: calcMinWidth({
      cta: cta,
      ctaExtra: ctaExtra
    })
  } : {};
  return /*#__PURE__*/_jsx("header", {
    className: rootClass,
    children: /*#__PURE__*/_jsxs(Wrap, {
      layout: layout,
      linkHero: center && !cta && url !== '',
      sticky: bottom,
      url: url,
      children: [title && /*#__PURE__*/_jsx("h1", {
        className: css.title,
        dangerouslySetInnerHTML: {
          __html: newLineToBreakTag(title)
        },
        style: {
          color: titleColor
        }
      }), subtitle && /*#__PURE__*/_jsx("h2", {
        className: css.subtitle,
        dangerouslySetInnerHTML: {
          __html: newLineToBreakTag(subtitle)
        },
        style: {
          color: subtitleColor
        }
      }), (hasCta || hasCtaExtra) && /*#__PURE__*/_jsxs("div", {
        className: cc([css.ctas, _defineProperty({}, css.multiCtas, hasCtaExtra)]),
        children: [hasCta && /*#__PURE__*/_jsx(ButtonLink, _objectSpread(_objectSpread({}, ctaButtonType), {}, {
          big: true,
          className: css.cta,
          href: url,
          style: style,
          children: cta
        })), hasCtaExtra && /*#__PURE__*/_jsx(ButtonLink, _objectSpread(_objectSpread({}, ctaExtraButtonType), {}, {
          big: true,
          className: cc([css.cta, css.ctaExtra]),
          href: urlExtra,
          style: style,
          children: ctaExtra
        }))]
      })]
    })
  });
};

Heading.defaultProps = _objectSpread({}, BLOCK_DEFAULTS);
Heading.propTypes = {
  buttonType: PropTypes.string,
  buttonTypeExtra: PropTypes.string,
  className: PropTypes.string,
  cta: PropTypes.string,
  ctaExtra: PropTypes.string,
  layout: PropTypes.string,
  overlayLeft: PropTypes.bool,
  subtitle: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  subtitleColor: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  titleColor: PropTypes.string,
  url: PropTypes.string,
  urlExtra: PropTypes.string,
  video: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()])
};
export default Heading;